export default function getResource(label, vars = []) {
    const resources = {
        edit: 'Modifier',
        artist: `Artist: ${vars[0]}`
    };

    return resources[label];
}
